/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{0994FF40-7336-4069-BEAD-E596A53562A1}",
  "sitecoreApiHost": "",
  "jssAppName": "cityofsydney",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/cityofsydney",
  "graphQLEndpoint": "/api/cityofsydney?sc_apikey={0994FF40-7336-4069-BEAD-E596A53562A1}"
};